__turbopack_context__.v({
  "actionButton": "link-module-scss-module__DKyrOa__actionButton",
  "centered": "link-module-scss-module__DKyrOa__centered",
  "container": "link-module-scss-module__DKyrOa__container",
  "hint": "link-module-scss-module__DKyrOa__hint",
  "overlay": "link-module-scss-module__DKyrOa__overlay",
});
